<div class="card card-wider card-cascade">
    <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center'>{{title}}</h3>
    </div>
    <div class="card-body">
        <div *ngIf="description" [innerHTML]="description"></div>
        <div *ngIf="!hasFocusQuestions" class="card card-cascade wider">
            <div class="view gradient-card-header secondary-gradient white-text">
                <h3 class='h3-responsive text-center'>Items of Concern</h3>
            </div>
            <div class="card-body">
                    <p>This client has no items of concern to address.</p>
            </div>
        </div>
        <div class="card card-cascade wider d-print-visible-block page-break-inside-avoid" *ngFor="let assessment of Assessments">
            <div class="view gradient-card-header secondary-gradient white-text">
                <h3 class='h3-responsive text-center'>{{assessment.name}}</h3>
            </div>
            <div class="card-body pt-1">
                <app-scale-questions-list [Questions]="getQuestionsForAssessment(assessment)"></app-scale-questions-list>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list/flagged-questions-list.component.html